var Codec = require('io/codec');

module.exports = {
    read : function(bis) {
        return {
            path : bis.readString(),
            id : bis.readInt32(),
            bytes : bis.readBytes()
        };
    },
    write : function(bos, req) {
        Codec.writeString(bos, req.path);
        Codec.writeInt32(bos, req.id);
        Codec.writeBytes(bos, req.bytes);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/update-topic/update-topic-delta-request-serialiser.js
// module id = 1054
// module chunks = 1